import { Heading, Stack } from '@chakra-ui/react';
import { FaRegFileLines } from 'react-icons/fa6';
import { PiReceipt } from 'react-icons/pi';
import CardManager from 'shared/components/CardManager';
import NfseLotes from './NfseLotes';
import NfseReportContext from './NfseReportContext';

const NfseHome = () => {
  return (
    <Stack
      minH="100vh"
      minW={{ lg: '740px' }}
      w={{ base: '90%', lg: '85%' }}
      m="auto"
      px={{ base: '1rem', lg: '4rem' }}
      pt={{ base: '1rem', lg: '1.5rem' }}
      pb={{ base: '2rem', lg: '4rem' }}
      gap="1.5rem"
    >
      <Heading size="lg" color="gray.600">
        Financeiro
      </Heading>
      <CardManager
        allTab={false}
        tabs={[
          { label: 'Relatório de DPS', icon: PiReceipt },
          { label: 'Lotes', icon: FaRegFileLines },
        ]}
      >
        <NfseReportContext />
        <NfseLotes />
      </CardManager>
    </Stack>
  );
};

export default NfseHome;
